import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import PaperViewer from "@/components/PaperViewer";
import TagEditor from "@/components/TagEditor";
import { useTaxonomies } from "@/lib/taxonomies";
import { describeTags, tagsOf } from "@/lib/taxonomy";

// onSaveTags(tags) থাকলে (রিভিউ বাকি/পাবলিশড পেপারে) মডারেটর ট্যাগ ঠিক করতে পারে।
export default function AdminPaperPreviewDialog({ paper, open, onOpenChange, actions, onSaveTags }) {
  const taxonomies = useTaxonomies();
  if (!paper) return null;

  const tags = describeTags(taxonomies, paper);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{paper.title}</DialogTitle>
          <DialogDescription>
            {paper.teacher_name || "নাম উল্লেখ করেননি"}
            {paper.institution ? ` · ${paper.institution}` : ""}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-wrap gap-1.5 mb-1">
          {tags.length === 0 && <span className="text-xs text-muted-foreground">কোনো ট্যাগ নেই</span>}
          {tags.map((t, i) => (
            <Badge key={`${t.key}:${t.value}`} variant={i < 2 ? "secondary" : "outline"}>
              {t.label}
            </Badge>
          ))}
        </div>

        {onSaveTags && (
          <details className="mb-3">
            <summary className="text-xs text-muted-foreground cursor-pointer select-none">ট্যাগ ঠিক করো</summary>
            <TagEditor key={paper.id} taxonomies={taxonomies} tags={tagsOf(paper)} onSave={onSaveTags} />
          </details>
        )}

        <PaperViewer paper={paper.paper_json} />

        {actions && <div className="no-print flex gap-2 mt-4 sticky bottom-0 bg-background pt-3 border-t border-border">{actions}</div>}
      </DialogContent>
    </Dialog>
  );
}
